import {Pathology, generatePath} from '@legit.health/ui';
import {ONE_HOUR_IN_MS} from '@legit.health/ui';
import {PATHOLOGIES} from '@/shared/const/backend';
import useApiQuery from '@/shared/hooks/useApiQuery';
import cachedDataState from './utils/cachedDataState';

export function getQueryKey() {
  return [PATHOLOGIES];
}

export default function usePathologies(isEnabled = true) {
  const path = generatePath(PATHOLOGIES, {}, null);
  return useApiQuery<Pathology[]>({
    queryOptions: {
      queryKey: getQueryKey(),
      staleTime: ONE_HOUR_IN_MS,
      enabled: isEnabled,
      onSuccess(response) {
        cachedDataState.set((c) => ({
          ...c,
          pathologies: response.data
        }));
      },
      suspense: true
    },
    requestArguments: {
      method: 'GET',
      path
    }
  });
}
